(function(w, d, $) {
	$(w).on('load', function(e) {
    const $selectElement = $('#subject');

		// Set select value depends on hash
		const hash = window.location.hash || null;

		if (hash === '#project') {
			$selectElement.prop('selectedIndex', 2);
		} else if (hash === '#reseller') {
			$selectElement.prop('selectedIndex', 0);
		}
	});
})(window, document, jQuery);
